/**
 * @description: 工单详情页左右结构
 * @author:
 */
<template>
  <div class="service-detail-page">
    <div class="main-wrap left-wrap">
      <div class="left-view" :style="leftStyle||{}">
        <slot name="left" />
      </div>
    </div>
    <div class="main-wrap right-view" :style="rightStyle||{}">
      <slot name="right" />
    </div>
  </div>
</template>

<script>
export default {
  props: ['left-style', 'right-style']
}
</script>

<style lang="scss" scoped>
.service-detail-page {
  display: flex;
  .left-view {
    width: 550px;
  }
  .right-view {
    flex: 1;
    border-left: 1px solid #ddd;
    @include border-color('lighter');
    &.main-wrap {
      padding-top: 14px;
      padding-bottom: 16px;
      border-radius: 0;
    }
  }
}
</style>
